import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Info } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export const AutoInvoiceToggle = ({ sched, onSaved }) => {
  const [target, setTarget] = useState(null);
  const [busy, setBusy] = useState(false);
  const on = sched.enabled === true;

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/billing/auto-invoice/automation", { enabled: target });
      onSaved(data);
      toast.success(`Pembuatan Invoice Otomatis ${data.enabled ? "diaktifkan" : "dinonaktifkan"}.`);
      setTarget(null);
    } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail) || "Gagal menyimpan status"); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-2 border-b pb-2" data-testid="autoinv-automation">
      <div className="flex items-start justify-between gap-3">
        <div className="space-y-0.5">
          <div className="font-bold text-[#111827]">Pembuatan Invoice Otomatis</div>
          <div className={on ? "text-[#047857]" : "text-[#B45309]"} data-testid="autoinv-automation-status">
            {on ? "Aktif: Invoice akan dibuat otomatis sesuai jadwal." : "Nonaktif: Invoice tidak akan dibuat otomatis. Proses manual tetap tersedia."}
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <span className="font-mono" data-testid="autoinv-automation-label">{on ? "Aktif" : "Nonaktif"}</span>
          <Switch checked={on} disabled={busy} onCheckedChange={(v) => setTarget(v)} data-testid="autoinv-automation-switch" />
        </div>
      </div>
      {on && sched.scheduler_enabled === false && (
        <div className="flex gap-2 rounded-md border border-[#E5E7EB] bg-[#F3F4F6] p-2 text-[#374151]" data-testid="autoinv-automation-env-info">
          <Info className="h-4 w-4 shrink-0 text-[#6B7280]" aria-hidden />
          <div>
            <div className="font-bold">Otomatisasi belum berjalan</div>
            <div>Pengaturan invoice otomatis di aplikasi sudah Aktif, tetapi penjadwalan otomatis belum diaktifkan di lingkungan ini. Proses manual tetap tersedia melalui Pratinjau → Jalankan.</div>
          </div>
        </div>
      )}
      <AlertDialog open={target !== null} onOpenChange={(v) => !v && !busy && setTarget(null)}>
        <AlertDialogContent data-testid="autoinv-automation-confirm">
          <AlertDialogHeader>
            <AlertDialogTitle>{target ? "Aktifkan" : "Nonaktifkan"} Pembuatan Invoice Otomatis?</AlertDialogTitle>
            <AlertDialogDescription>
              {target
                ? "Invoice akan dibuat otomatis pada jadwal berikutnya. Mengaktifkan tidak membuat invoice sekarang dan tidak memproses periode yang terlewat."
                : "Scheduler tidak akan membuat invoice otomatis mulai pemeriksaan berikutnya. Invoice, jadwal, dan riwayat run yang ada tidak diubah. Proses manual tetap tersedia."}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={busy} data-testid="autoinv-automation-cancel">Batal</AlertDialogCancel>
            <AlertDialogAction disabled={busy} onClick={(e) => { e.preventDefault(); save(); }} data-testid="autoinv-automation-confirm-btn">
              {busy ? "Menyimpan…" : target ? "Ya, Aktifkan" : "Ya, Nonaktifkan"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
